import styled from 'styled-components'
import { IErrorData } from 'types/errorTypes'
import { sendLogs } from 'utils'
import { ErrorMessage } from './ErrorMessage'

interface IProps {
  size?: number
  className?: string
  message?: string | number
  title?: string | number
  details?: null | IErrorData
  image?: JSX.Element
}

export const ErrorBox = ({ className, size = 1, title = '', message = '', image, details }: IProps) => {
  sendLogs({ message: details })
  return (
    <Div className={className}>
      <div className="d-flex align-items-center justify-content-center gap-1">
        {title && <ErrorMessage message={title} size={2} />}
      </div>

      {message && <ErrorMessage message={message} size={size} />}

      <div className="mt-3">{image}</div>
    </Div>
  )
}

const Div = styled.div`
  position: absolute !important;
  inset: 0 0 0 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: transparent;
  z-index: 3;
  text-align: center;

  svg{
    width:243px;
    height:221px;
  }

  > * {
    max-width: 30rem;
  }
`
